export enum AttemptStatusType {
  Unassigned = "Unassigned",
  Assigned = "Assigned",
  Started = "Started",
  HeadingPickup = "HeadingPickup",
  ArrivedPickup = "ArrivedPickup",
  PickedUp = "PickedUp",
  HeadingDestination = "HeadingDestination",
  ArrivedDestination = "ArrivedDestination",
  Aborted = "Aborted",
  Completed = "Completed",
  Canceled = "Canceled"
}
